import { render, staticRenderFns } from "./the-drawer-minifier.vue?vue&type=template&id=3fb3d53c"
import script from "./the-drawer-minifier.vue?vue&type=script&lang=js"
export * from "./the-drawer-minifier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports